var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4961_98677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 9.23159V9.99826C18.3317 11.7953 17.7498 13.5438 16.6738 14.9831C15.5978 16.4224 14.0854 17.4753 12.3621 17.9848C10.6389 18.4944 8.79707 18.4332 7.11141 17.8104C5.42575 17.1877 3.98656 16.0367 3.00848 14.5291C2.0304 13.0216 1.56584 11.2383 1.68408 9.44519C1.80232 7.65206 2.49702 5.9452 3.66458 4.57915C4.83214 3.21311 6.41 2.26108 8.16284 1.86505C9.91568 1.46902 11.7496 1.65021 13.391 2.38159",
    stroke: "#1B4458",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33203L10 11.6737L7.5 9.1737",
    stroke: "#1B4458",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4961_98677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.08bb921417dfe0768d1ef81da37adf1a.svg";
export { ForwardRef as ReactComponent };